import { render, staticRenderFns } from "./WidgetChart.vue?vue&type=template&id=d3d06964"
import script from "./WidgetChart.vue?vue&type=script&lang=js"
export * from "./WidgetChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports